export default __webpack_public_path__ + "static/media/left-chart-template.png?.2ad9f9a1";